import { jsx as _jsx } from "react/jsx-runtime";
import isString from 'lodash/isString';
import { useEffect, useState, } from 'react';
import classnames from 'classnames';
import { Placeholder } from '../Placeholder';
const fetchCountryFlag = (code) => import(
/* webpackMode: "lazy" */
/* webpackChunkName: "cata_style_flags" */
`../../../src/assets/cata_style_flags/${code}.svg`
// NOTE: the path above looks weird, but it's necessary, since we need to reference a path outside of the
// dist folder in which component resides when built for production
).then((module) => module.default);
export const CountryFlag = ({ as, size = 's', placeholderCols = 5, code, title = '', alt, className, ...rest }) => {
    const Component = as || 'img';
    const normalizedCode = code.toLowerCase();
    const [loading, setLoading] = useState(false);
    const [src, setSrc] = useState('');
    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        fetchCountryFlag(normalizedCode)
            .catch(() => '')
            .then((result) => {
            if (cancelled) {
                return;
            }
            if (isString(result)) {
                setSrc(result);
            }
            else {
                setSrc(result.src);
            }
            setLoading(false);
        });
        return () => {
            cancelled = true;
        };
    }, [normalizedCode]);
    if (loading) {
        return (_jsx(Placeholder, { as: "span", className: className, cols: placeholderCols }));
    }
    if (!src) {
        return null;
    }
    return (_jsx(Component, { ...rest, className: classnames(`u-icon-${size}`, className), src: src, alt: alt, title: title }));
};
//# sourceMappingURL=CountryFlag.js.map